module.exports = __webpack_public_path__ + "static/img/img_guide4.8a3639ae.png";